import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { EditIconButton } from "../../../../app/components/iconButtons/EditIconButton";
import { Localized } from "@fluent/react";

export type FieldKey = "legalName" | "shortName" | "about" | "yearFounded"
    | "companySizeTierId" | "quickTags" | "websiteUrl" | "primaryEmail"
    | "salesEmail" | "supportEmail" | "phone" | "whatsApp" | "hQ_Street"
    | "hQ_BuildingNumber" | "hQ_UnitNumber" | "hQ_AddressAdditional"
    | "hQ_City" | "hQ_Region" | "hQ_RegionCode" | "hQ_PostalCode" | "hQ_CountryCode"
    | "hQ_CountryName" | "hQ_Coordinates" | "selectedPlatforms" | "regionMarkets" 
    | "countryMarkets" | "socialLink" | "certificates" | "marketplace";

type KeyValueRowProps = {
    field: FieldKey;
    icon?: React.ReactNode;
    label: React.ReactNode;
    value: React.ReactNode;
    multiline?: boolean;
    labelCols?: number; // domyślnie 2
    valueCols?: number; // domyślnie 10
    openEdit: (field: FieldKey, value?: React.ReactNode | null) => void;
    
};

export const KeyValueRow = ({
    field,
    label,
    value,
    multiline = false,
    labelCols = 2,
    valueCols = 10,
    openEdit,
    icon,
}: KeyValueRowProps) => (
    <Grid
        container
        spacing={1.5}
        alignItems="stretch"
        sx={{
            py: 0.75,
            borderBottom: (t) => `1px dashed ${t.palette.divider}`,
            "&:last-of-type": { borderBottom: "none" },
        }}
    >
        {/* label */}
        <Grid item xs={12} sm={labelCols}>
            <Box
                sx={(t) => ({
                    bgcolor: t.palette.grey[100],
                    border: `1px solid ${t.palette.grey[200]}`,
                    borderRadius: 1,
                    px: 1,
                    py: 0.75,
                    height: "100%",
                    display: "flex",
                    alignItems: multiline ? "flex-start" : "center",
                    gap: icon ? 1 : 0,
                })}
            >
                {icon && (
                    <Box sx={{ display: "flex", alignItems: "center", color: "text.secondary" }}>
                        {icon}
                    </Box>
                )}
                <Typography variant="body2" fontWeight={600} color="text.secondary">{label}</Typography>
            </Box>
        </Grid>

        {/* value */}
        <Grid item xs={12} sm={valueCols}>
            <Box
                sx={(t) => ({
                    border: `1px solid ${t.palette.grey[200]}`,
                    bgcolor: t.palette.grey[50],
                    borderRadius: 1,
                    px: 1.25,
                    py: 0.75,
                    height: "100%",
                    display: "flex",
                    alignItems: multiline ? "flex-start" : "center",
                    justifyContent: "space-between"
                })}
            >
                <Typography
                    variant="body1"
                    fontWeight={600}
                    sx={multiline ? { whiteSpace: "pre-line" } : undefined}
                >
                    {value}
                </Typography>
                <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    px: 0.5,
                    "&:hover .editIcon, &:focus-within .editIcon": {
                        color: "info.main",
                    },
                }}
            >
                <EditIconButton
                    tooltip={<Localized id='edit'>_edit</Localized>}
                    onClick={() => openEdit(field, value)}  
                />
            </Box>
            </Box>
        </Grid>
    </Grid>
);
